import React from 'react';
import { Page } from '../Page';
export function PageGutSide() {
  return <Page pageNumber={3} variant="light" data-id="element-1225">
      <div className="flex flex-col h-full" data-id="element-1226">
        <div className="mb-8 pt-4" data-id="element-1227">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1228">
            Understanding Your Medication
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1229">
            GLP-1 And <span className="text-tealslate" data-id="element-1230">The Gut</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate mb-4" data-id="element-1231" />
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-md" data-id="element-1232">
            The physical changes to your digestion that create lasting fullness.
          </p>
        </div>

        <p className="text-[10px] text-[#7A7A70] tracking-wider font-bold mb-1" data-id="element-1233">
          <em data-id="element-1234">Figure 1</em>
        </p>
        <div className="flex-1 -mx-12 px-12 flex flex-col justify-center" data-id="element-1235">
          <div className="flex justify-center" data-id="element-1236">
            <img src="https://cdn.magicpatterns.com/uploads/dysD2x9V1S39AoBcTvTWYN/Picture1.png" alt="Digestive system diagram showing how food stretches the stomach and activates stretch receptors" className="h-[637px] object-contain" data-id="element-1237" />
          </div>
        </div>

        <div className="pt-6" data-id="element-1238">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1239">
            <strong className="text-[#1F1F1F]" data-id="element-1240">How it works:</strong>{' '}
            <em data-id="element-1241">
              The medication slows the release of food from your stomach into
              the intestine. As food sits longer, stretch receptors fire and
              tell your brain you're full. The result: smaller portions feel
              like enough.
            </em>
          </p>
        </div>
      </div>
    </Page>;
}